import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

export const selectParams = (state: RootState) => state.supportAtHome.clientsWithBudgets?.params;
export const selectClientsWithBudgets = (state: RootState) => state.supportAtHome.clientsWithBudgets?.rows || [];
export const selectClientsWithBudgetsLoading = (state: RootState) => state.supportAtHome.clientsWithBudgets.loading;
export const selectClientsWithBudgetsTotal = (state: RootState) => state.supportAtHome.clientsWithBudgets.total;

export const selectClientWithBudgetsById = createSelector(
  [selectClientsWithBudgets, (_: RootState, id?: number) => id],
  (rows, id) => rows.find(({ id: rowId }) => id === rowId),
);
